import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import config from 'config';
import { schema } from '@techstyle/redux-core';
import { markMalformedString } from './utils';
import logger from './logger';
var debug = logger.extend('schema');
var malformedGroupRegex = /((?:^[^\w])|(?:[^\w&+-]))/g;
var malformedKeyRegex = /((?:^[^\w])|(?:[^\w.&+-])|(?:[^\w&+-]$))/g;
export function printResourceBundleWarnings(value) {
  var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : debug;
  var groupCode = value.groupCode;
  var malformed = [];

  var _markMalformedString = markMalformedString(groupCode, malformedGroupRegex),
      _markMalformedString2 = _slicedToArray(_markMalformedString, 2),
      isMalformed = _markMalformedString2[0],
      markers = _markMalformedString2[1];

  if (isMalformed) {
    malformed.push([groupCode, null, markers]);
  }

  Object.keys(value.resources).forEach(function (key) {
    var _markMalformedString3 = markMalformedString(key, malformedKeyRegex),
        _markMalformedString4 = _slicedToArray(_markMalformedString3, 2),
        isMalformed = _markMalformedString4[0],
        markers = _markMalformedString4[1];

    if (isMalformed) {
      malformed.push([groupCode, key, markers]);
    }
  });

  if (malformed.length) {
    log("Resource bundle \u201C".concat(groupCode, "\u201D had the following issues. Correct them to fix this warning."));
    malformed.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          groupCode = _ref2[0],
          key = _ref2[1],
          markers = _ref2[2];

      if (key == null) {
        log("\u2022 Malformed group code \u201C".concat(groupCode, "\u201D"));
        log("                        %c%s%c ", 'color: red', markers, '');
      } else {
        log("\u2022 Malformed key \u201C".concat(key, "\u201D"));
        log("                 %c%s%c ", 'color: red', markers, '');
      }
    });
  }
}
export function generateFilterOptions() {
  var configMessages = config.get('server.intl.messages');
  var namespaces = Object.keys(configMessages);
  var messageIds = Object.values(configMessages).reduce(function (combined, messages) {
    if (messages) {
      var ids = messages.map(function (message) {
        return message.id;
      });

      if (combined) {
        return [].concat(_toConsumableArray(combined), _toConsumableArray(ids));
      }

      return ids;
    }

    return combined;
  }, null);
  var configDynamicMessageRbs = config.get('server.intl.dynamicMessages');
  var dynamicMessageRbs = Object.values(configDynamicMessageRbs).reduce(function (combined, groupCodes) {
    if (groupCodes) {
      if (combined) {
        return [].concat(_toConsumableArray(combined), _toConsumableArray(groupCodes));
      }

      return groupCodes;
    }

    return combined;
  }, null);

  if (messageIds) {
    debug('Message filtering enabled: found %d message(s) from %d package(s) in %cserver.intl.messages%c.', messageIds.length, namespaces.length, 'font-weight: bold', '');
  } else {
    debug('Message filtering disabled: %cserver.intl.messages%c did not define any messages. This is expected in development mode; in production, it indicates that the %cintl:extract-messages%c script was not run.', 'font-weight: bold', '', 'font-weight: bold', '');
  }

  return {
    messageIds: messageIds && new Set(messageIds),
    dynamicMessageRbs: dynamicMessageRbs && new Set(dynamicMessageRbs)
  };
}
var filterOptions;
export function filterResourceBundle(resourceBundle) {
  if (process.browser || !config.get('server.intl.enableMessageFiltering')) {
    return resourceBundle;
  }

  if (!filterOptions) {
    filterOptions = generateFilterOptions();
  }

  var _filterOptions = filterOptions,
      messageIds = _filterOptions.messageIds,
      dynamicMessageRbs = _filterOptions.dynamicMessageRbs;

  if (dynamicMessageRbs && dynamicMessageRbs.has(resourceBundle.groupCode)) {
    debug('Skipped filtering for resource bundle “%s” since it appears in %cserver.intl.dynamicMessages%c.', resourceBundle.groupCode, 'font-weight: bold', '');
    return resourceBundle;
  }

  if (messageIds) {
    var filteredCount = 0;
    resourceBundle = _objectSpread(_objectSpread({}, resourceBundle), {}, {
      resources: Object.entries(resourceBundle.resources).reduce(function (filteredResources, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            messageKey = _ref4[0],
            messageValue = _ref4[1];

        var id = "".concat(resourceBundle.groupCode, ".").concat(messageKey);

        if (messageIds.has(id)) {
          filteredResources[messageKey] = messageValue;
        } else {
          filteredCount++;
        }

        return filteredResources;
      }, {})
    });

    if (filteredCount) {
      debug('Filtered %s message(s) from resource bundle “%s” that did not appear in %cserver.intl.messages%c.', filteredCount, resourceBundle.groupCode, 'font-weight: bold', '');
    }
  }

  return resourceBundle;
}
export var ResourceBundle = new schema.Entity('ResourceBundle', {}, {
  idAttribute: 'groupCode',
  processStrategy: function processStrategy(input) {
    if (debug.enabled) {
      printResourceBundleWarnings(input);
    }

    return filterResourceBundle(_objectSpread(_objectSpread({}, input), {}, {
      locale: input.locale ? input.locale.replace('_', '-') : null
    }));
  }
});